// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 引入富文本组件
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
// 引入富文本组件
import scroll from 'vue-seamless-scroll'
Vue.use(scroll);

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
// axios.defaults.headers.common['X-Client-Id'] = 'zr_platform';
Vue.prototype.$axios = axios;

// Import ID utilities
import { installIdUtils, processObjectIds, enableLargeIdLogging } from '@/utils/id-utils';
import IdDisplay from '@/components/common/IdDisplay';

// Register IdDisplay component globally
Vue.component('id-display', IdDisplay);

// Install ID utilities in Vue
installIdUtils(Vue);

// Process ID fields in all API responses to ensure they're handled correctly
axios.interceptors.response.use(response => {
  // Process ID fields in response data
  if (response.data && typeof response.data === 'object') {
    response.data = processObjectIds(response.data);
  }
  return response;
}, error => {
  return Promise.reject(error);
});

// Enable logging of large IDs in development mode
if (process.env.NODE_ENV === 'development') {
  enableLargeIdLogging(axios);
}

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
import {
  loginout,
  getInfo,
  refreshToken,
  checkUserPermission,
  checkRolePermissionUpdate
} from "./api/userMG";
// 路由拦截器
router.beforeEach((to, from, next) => {
  // 获取路由的meta信息
  const meta = to.meta || {};
  console.log('访问路径:', to.path, 'meta完整信息:', to.meta, 'menuId:', meta.menuId);
  
  // 不需要登录验证的路由直接通过
  if (to.path == "/" || to.path == "/login"|| to.path == "/system/login"|| to.path == "/404" 
    || to.path == "/401" || to.path == "/402" || to.path=='/productAll'||to.path=='/product'
    ||to.path=='/aggregate'||to.path=='/enterprise' ||to.path=='/productPay'  ||to.path=='/paySuccess'||
     to.path == "/auth/callback"  || to.path=='/register' || to.path=='/forgot-password') {
    next();
  } else {
    // 获取用户信息
    getInfo().then((res) => {
      if (res.code == 200) {
        // 保存用户信息
        localStorage.setItem("userdata", JSON.stringify(res.data.user));
        localStorage.setItem("company", JSON.stringify(res.data.company));
        
        // 保存角色权限
        if (res.data.sysRolePower != null && res.data.sysRolePower.length > 0) {
          localStorage.setItem("sysRolePower", JSON.stringify(res.data.sysRolePower));
        } else {
          localStorage.removeItem('sysRolePower');
        }
        
        // 先检查用户是否为管理员或创建者，决定是否需要进行菜单权限检查
        checkUserPermission().then((permRes) => {
          if (permRes.code == 200 && permRes.data.hasFullPermission) {
            // 用户是管理员或创建者，直接允许访问
            console.log('用户是管理员或创建者，允许访问所有页面');
            next();
          } else {
            // 用户是普通用户，需要检查菜单权限
            
            // 保存菜单权限ID列表
            if (res.data.userMenuIds != null && res.data.userMenuIds.length > 0) {
              console.log('后端返回的菜单ID列表:', res.data.userMenuIds);
              localStorage.setItem("userMenuIds", JSON.stringify(res.data.userMenuIds));
              
              // 重新获取最新的路由信息
              const updatedMeta = to.meta || {};
              console.log('获取用户信息后，再次检查路由meta:', updatedMeta, 'menuId:', updatedMeta.menuId);
              
              // 检查当前路由是否有权限访问
              checkRoutePermission(to, next);
            } else {
              /*console.warn('后端未返回菜单ID列表');
              localStorage.removeItem('userMenuIds');
              
              if (!to.meta || !to.meta.menuId) {
                // 若路由没有配置menuId，则默认允许访问
                console.log('路由未配置menuId，默认允许访问:', to.path);
                next();
              } else {
                // 没有菜单权限且不是管理员，且路由需要menuId权限，则拒绝访问
                console.warn('用户无权访问:', to.path);
                next('/401');
              }*/
                next();
            }
            
          }
          
          // 保存供应商信息
          if (res.data.supplierInfo != null) {
            localStorage.setItem("supplierInfo", JSON.stringify(res.data.supplierInfo));
          } else {
            localStorage.removeItem('supplierInfo');
          }
        }).catch(err => {
          console.error('检查用户权限失败:', err);
          // 权限检查失败时，使用默认的权限检查逻辑
          
          // 保存菜单权限ID列表
          if (res.data.userMenuIds != null && res.data.userMenuIds.length > 0) {
            console.log('后端返回的菜单ID列表:', res.data.userMenuIds);
            localStorage.setItem("userMenuIds", JSON.stringify(res.data.userMenuIds));
            
            // 检查当前路由是否有权限访问
            checkRoutePermission(to, next);
          } else {
            console.warn('后端未返回菜单ID列表');
            localStorage.removeItem('userMenuIds');
            next();
          }
        });
      } else {
        // 登录失败，清除缓存并跳转到登录页
        loginout().then((res) => {
          localStorage.clear();
          localStorage.removeItem("userdata");
          localStorage.removeItem("company");
          localStorage.removeItem("supplierInfo");
          localStorage.removeItem('sysRolePower');
          localStorage.removeItem('userMenuIds');
          next({
            path: '/login'
          });
        });
      }
    }).catch(err => {
      console.error('获取用户信息失败:', err);
      next('/login');
    });
  }
});

// 加载用户菜单权限
function loadUserMenuPermissions(userId, userRoles) {
  console.log('开始加载用户菜单权限, 用户ID:', userId);
  
  // 提取用户角色ID
  const roleIds = userRoles.map(role => role.roleId);
  console.log('用户角色列表:', roleIds);
  
  // 如果用户没有角色，直接返回
  if (!roleIds || roleIds.length === 0) {
    console.warn('用户没有分配角色，无法获取菜单权限');
    localStorage.setItem('userMenuPermissions', JSON.stringify([]));
    return Promise.resolve();
  }
  
  // 创建加载所有角色菜单权限的Promise数组
  const promises = roleIds.map(roleId => {
    return loadRoleMenuPermissions(roleId);
  });
  
  // 等待所有Promise完成
  return Promise.all(promises)
    .then(results => {
      // 合并所有角色的菜单权限
      let allMenuIds = [];
      results.forEach(menuIds => {
        if (menuIds && menuIds.length > 0) {
          allMenuIds = [...new Set([...allMenuIds, ...menuIds])];
        }
      });
      
      // 保存菜单权限到localStorage
      localStorage.setItem('userMenuPermissions', JSON.stringify(allMenuIds));
      console.log('用户菜单权限已加载完成:', allMenuIds);
      
      // 触发菜单更新事件
      window.dispatchEvent(new CustomEvent('menu-permissions-updated'));
    });
}

// 加载角色的菜单权限
function loadRoleMenuPermissions(roleId) {
  console.log(`开始获取角色[${roleId}]的菜单权限`);
  
  return new Promise((resolve, reject) => {
    // 带上时间戳参数防止浏览器缓存
    const timestamp = new Date().getTime();
    axios.get(`/zr-admin/systemMenu/roleMenuTreeselect/${roleId}?_t=${timestamp}`)
      .then(response => {
        if (response.data.code === 200) {
          console.log(`角色[${roleId}]菜单权限获取成功:`, response.data.data);
          resolve(response.data.data || []);
        } else {
          console.warn(`获取角色[${roleId}]菜单权限失败:`, response.data.msg);
          resolve([]);
        }
      })
      .catch(error => {
        console.error(`获取角色[${roleId}]菜单权限发生错误:`, error);
        resolve([]);
      });
  });
}

// 检查路由权限
function checkRoutePermission(to, next) {
  // 检查用户类型
  const userdata = localStorage.getItem('userdata');
  let isAdmin = false;
  if (userdata) {
    try {
      const userData = JSON.parse(userdata);
      isAdmin = userData.userType === 'admin' || userData.userType === '0' || 
               userData.userType === 'creator' || userData.userType === '1';
      
      // 如果是管理员或创建者，直接允许访问所有页面，无需检查menuId
      if (isAdmin) {
        console.log('用户是管理员或创建者，允许访问所有页面');
        next();
        return;
      }
    } catch (e) {
      console.error('解析用户数据失败:', e);
    }
  }
  
  // 获取用户菜单权限 (非管理员才需要检查)
  let userMenuIds = [];
  try {
    const userMenuIdsStr = localStorage.getItem('userMenuIds');
    if (userMenuIdsStr) {
      userMenuIds = JSON.parse(userMenuIdsStr);
      console.log('当前普通用户的菜单权限ID列表:', userMenuIds);
    }
  } catch (e) {
    console.error('解析菜单权限数据失败:', e);
  }

  // 首先检查匹配的路由记录，通常是最外层的 /auth 路由
  let menuId = null;
  // 尝试从当前路由获取menuId
  if (to.meta && to.meta.menuId) {
    menuId = to.meta.menuId;
    console.log('从当前路由获取menuId:', menuId);
  } 
  // 如果当前路由没有menuId，尝试从匹配的路由记录中找到
  else if (to.matched && to.matched.length > 0) {
    // 遍历匹配的路由记录，从子路由到父路由
    for (let i = to.matched.length - 1; i >= 0; i--) {
      const record = to.matched[i];
      if (record.meta && record.meta.menuId) {
        menuId = record.meta.menuId;
        console.log(`从匹配的路由记录[${i}]获取menuId:`, menuId);
        break;
      }
    }
  }
  
  console.log('最终确定的menuId:', menuId);
  
  // 如果没有找到menuId要求，直接允许访问
  if (!menuId) {
    console.log('路由无需menuId权限验证，允许访问');
    next();
    return;
  }
  
  // 检查用户是否有权限访问该路由
  const hasPermission = userMenuIds.includes(menuId) || 
                      userMenuIds.includes(String(menuId));
  
  if (hasPermission) {
    console.log('用户有权限访问该路由，menuId:', menuId);
    next();
  } else {
    console.warn('用户无权访问，缺少menuId权限:', menuId);
    next('/401'); // 跳转到无权限页面
  }
}

// 添加权限自动刷新功能
let lastPermissionCheckTime = Date.now();

// 定期检查权限更新
function setupPermissionUpdateChecker() {
  // 每30秒检查一次权限更新
  const checkInterval = 30 * 1000; 
  
  setInterval(() => {
    // 只有登录后才检查
    const token = localStorage.getItem('logintoken');
    if (!token) return;
    
    // 检查角色权限是否有更新
    checkRolePermissionUpdate(lastPermissionCheckTime)
      .then(res => {
        if (res.code === 200 && res.data && res.data.hasUpdate) {
          console.log('检测到角色权限已更新，正在刷新用户权限...');
          
          // 更新最后检查时间
          lastPermissionCheckTime = res.data.lastUpdateTime;
          
          // 清除权限缓存
          localStorage.removeItem('userMenuPermissions');
          localStorage.removeItem('userMenuIds');
          
          // 重新获取用户信息，包括权限
          getInfo().then(infoRes => {
            if (infoRes.code === 200) {
              console.log('权限已更新，正在刷新菜单');
              
              // 保存用户信息
              localStorage.setItem("userdata", JSON.stringify(infoRes.data.user));
              
              // 保存新的菜单权限
              if (infoRes.data.userMenuIds != null && infoRes.data.userMenuIds.length > 0) {
                localStorage.setItem("userMenuIds", JSON.stringify(infoRes.data.userMenuIds));
              }
              
              // 触发菜单更新事件
              window.dispatchEvent(new CustomEvent('menu-permissions-updated'));
              
              // 提示用户权限已更新
              if (Vue.$message) {
                Vue.$message.info('您的权限已更新，菜单将自动刷新');
              }
            }
          }).catch(err => {
            console.error('刷新权限失败:', err);
          });
        } else {
          // 更新最后检查时间
          if (res.data && res.data.lastUpdateTime) {
            lastPermissionCheckTime = res.data.lastUpdateTime;
          }
        }
      })
      .catch(err => {
        console.error('检查权限更新失败:', err);
      });
  }, checkInterval);
}

// 在Vue实例初始化后启动权限检查
setupPermissionUpdateChecker();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store vuex状态管理
  components: {
    App
  },
  template: '<App/>',
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  }

})



// WEBPACK FOOTER //
// ./src/main.js